import { MdHelpOutline, MdPersonAdd } from 'react-icons/md';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Tooltip, Whisper } from 'rsuite';
import { RootState } from '../../../@types/RootState';
import { selectorUser } from '../../../lib/selectorUser';
import { setClickToLocalStorage } from '../../../utils/setClickToLocalStorage';
import NavBarUserMenu from '../NavBarUserMenu/NavBarUserMenu';
import styles from './NavBarActions.module.scss';

type NavBarActionsProps = ReturnType<typeof mapStateToProps>;

const NavBarActions = ({ user }: NavBarActionsProps) => {
  const handleClickKnowledgeBase = () => {
    setClickToLocalStorage('centralAjuda', 'botao-ajuda', user);
  };

  return (
    <div className={styles.wrapper}>
      {user?.usuarioAdministrador && (
        <Whisper trigger="hover" placement="bottom" speaker={<Tooltip>Convidar Pessoas</Tooltip>}>
          <Link to="/administrador/pessoas" className={styles.link} id="admin-people-navbar-link">
            <MdPersonAdd size={20} />
          </Link>
        </Whisper>
      )}
      <Whisper trigger="hover" placement="bottom" speaker={<Tooltip>Base de conhecimento</Tooltip>}>
        <Link to={{ pathname: 'https://www.infoprice.co/base-de-conhecimento/infopanel/' }} target="_blank" className={styles.link} onClick={handleClickKnowledgeBase}>
          <MdHelpOutline size={20} />
        </Link>
      </Whisper>
      <NavBarUserMenu />
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  user: selectorUser(state),
});

export default connect(mapStateToProps)(NavBarActions);
